import API_BASE_URL from "../utils/config";
import request from "../utils/request";

function toFormData(data) {
  const formData = new FormData();
  formData.append("name", data.name);
  formData.append("description", data.description);
  formData.append("isActive", data.isActive);
  if (data.image) formData.append("image", data.image);
  return formData;
}

export async function postExamGroup(data) {
  const url = `${API_BASE_URL}/exam-groups`;
  const formData = toFormData(data);

  return request({
    url,
    method: "post",
    formData,
    upload: true,
    config: {
      headers: {
        "content-type": "multipart/form-data",
      },
    },
  });
}

export async function fetchAll(data) {
  const url = `${API_BASE_URL}/exam-groups`;
  return request({
    url,
    method: "get",
    data
  });
}

export async function getGroup(id) {
  const url = `${API_BASE_URL}/exam-groups/${id}`;
  return request({
    url,
    method: "get",
  });
}

export async function postEdit(data) {
  const { id } = data;
  const url = `${API_BASE_URL}/exam-groups/${id}`;
  const formData = toFormData(data);

  return request({
    url,
    method: "put",
    formData,
    upload: true,
    config: {
      headers: {
        "content-type": "multipart/form-data",
      },
    },
  });
}

export async function deleteExamGroup(id) {
  const url = `${API_BASE_URL}/exam-groups/${id}`;
  return request({
    url,
    method: "delete",
  });
}
